/* Predictive search dropdown for the header search box (pel-freez.com had Magento autocomplete).
   Products come from the theme's own index (assets/search-index.json, built by
   crm_v20.storefront.build_search_index): every query word must prefix-match a word of the
   title, a SKU, the product's categories or its alternate names, and the hits are ordered by
   sales popularity (pelfreez.popularity) -- Shopify's predictive API ranks by text relevance
   only, ANDs the words against the copy and stops at 10, which put Ferret and Llama ahead of
   Rabbit Whole Blood for "animal whole blood" and left Rabbit out. Pages / articles (and any
   product the index does not know yet) still come from the `predictive-search` section through
   the Section Rendering API on /search/suggest. Vanilla, debounced, no deps. */
(function () {
  'use strict';

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 250;
  var MAX_PRODUCTS = 8;
  var indexPromise = null;

  /* "Anti-Tyrosine", "IgG/IgM", "31061-3" split at the punctuation so "tyrosine" / "igm" / "31061" hit. */
  function words(s) { return String(s || '').toLowerCase().match(/[a-z0-9]+(?:\.[0-9]+)?/g) || []; }

  /* rows: [handle, title, skus, terms, popularity, image filename] -> searchable records */
  function loadIndex(url) {
    if (indexPromise) return indexPromise;
    indexPromise = fetch(url).then(function (r) { return r.ok ? r.json() : []; }).then(function (rows) {
      return rows.map(function (r) {
        return { handle: r[0], title: r[1], skus: r[2] || '', pop: r[4] || 0, img: r[5] || '',
                 titleWords: words(r[1]), otherWords: words(r[2]).concat(words(r[3])) };
      });
    }).catch(function () { return []; });
    return indexPromise;
  }

  function prefixIn(list, tok) {
    for (var i = 0; i < list.length; i++) { if (list[i].indexOf(tok) === 0) return true; }
    return false;
  }

  /* All query words must match. Products whose TITLE carries every word come first ("rabbit serum"
     is the rabbit sera, not the complement whose alternate names mention serum), then popularity,
     then how many words hit the title, then A-Z. */
  function rank(index, q) {
    var toks = words(q);
    if (!toks.length) return [];
    var hits = [];
    for (var i = 0; i < index.length; i++) {
      var rec = index[i], titleHits = 0, ok = true;
      for (var t = 0; t < toks.length; t++) {
        if (prefixIn(rec.titleWords, toks[t])) titleHits++;
        else if (!prefixIn(rec.otherWords, toks[t])) { ok = false; break; }
      }
      if (ok) hits.push({ rec: rec, titleHits: titleHits });
    }
    hits.sort(function (a, b) {
      var aFull = a.titleHits === toks.length ? 1 : 0, bFull = b.titleHits === toks.length ? 1 : 0;
      return (bFull - aFull) || (b.rec.pop - a.rec.pop) || (b.titleHits - a.titleHits) || a.rec.title.localeCompare(b.rec.title);
    });
    return hits.map(function (h) { return h.rec; });
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function productItem(rec) {
    var li = el('li');
    var a = el('a', 'predictive__item');
    a.href = '/products/' + encodeURIComponent(rec.handle);
    a.setAttribute('role', 'option');
    if (rec.img) {
      var img = el('img', 'predictive__img');
      img.src = '/cdn/shop/files/' + rec.img + '?width=96';
      img.alt = ''; img.width = 48; img.height = 48; img.loading = 'lazy';
      a.appendChild(img);
    } else {
      a.appendChild(el('span', 'predictive__img predictive__img--empty'));
    }
    var text = el('span', 'predictive__text');
    text.appendChild(el('span', 'predictive__title', rec.title));
    var skus = rec.skus.split(' ').filter(Boolean).slice(0, 3).join(', ');
    if (skus) text.appendChild(el('span', 'predictive__meta', skus));
    a.appendChild(text);
    li.appendChild(a);
    return li;
  }

  /* Replace the section's relevance-ordered product column with the ranked one; a product the
     API knows but the index does not (added since the last index build) is appended. */
  function mergeProducts(panel, ranked, label) {
    var cols = panel.querySelectorAll('.predictive__col');
    var productCol = null, apiItems = [];
    for (var i = 0; i < cols.length; i++) {
      var links = cols[i].querySelectorAll('a.predictive__item:not(.predictive__item--text)');
      if (links.length) { productCol = cols[i]; apiItems = Array.prototype.slice.call(links); break; }
    }
    var seen = {}, items = [];
    ranked.forEach(function (rec) { if (items.length < MAX_PRODUCTS) { seen['/products/' + rec.handle] = true; items.push(productItem(rec)); } });
    apiItems.forEach(function (a) {
      var path = a.getAttribute('href').split('?')[0];
      if (!seen[path] && items.length < MAX_PRODUCTS) { seen[path] = true; items.push(a.parentNode.cloneNode(true)); }
    });
    if (!items.length) return;
    if (!productCol) {
      productCol = el('div', 'predictive__col');
      productCol.appendChild(el('h3', 'predictive__group', label));
      panel.insertBefore(productCol, panel.firstChild);
      var none = panel.querySelector('.predictive__none');
      if (none) none.remove();
    }
    var list = productCol.querySelector('.predictive__list') || productCol.appendChild(el('ul', 'predictive__list'));
    list.setAttribute('role', 'list');
    list.innerHTML = '';
    items.forEach(function (li) { list.appendChild(li); });
    panel.classList.toggle('predictive__panel--split', panel.querySelectorAll('.predictive__col').length > 1);
  }

  function init(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-predictive-search]'), function (wrap) {
      if (wrap.__predictive) return;
      wrap.__predictive = true;
      var input = wrap.querySelector('input[type="search"]');
      var results = wrap.querySelector('[data-predictive-results]');
      var url = wrap.getAttribute('data-predictive-url') || '/search/suggest';
      var indexUrl = wrap.getAttribute('data-predictive-index');
      var productsLabel = wrap.getAttribute('data-str-products') || 'Products';
      if (!input || !results) return;

      var timer = null, controller = null, lastQuery = '';

      function close() {
        results.hidden = true;
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      function fetchResults(q) {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        // limit_scope=each: up to 5 products AND up to 5 pages/articles (the default `all` shares
        // one budget of 5, so a lone SKU hit was buried under four publication titles)
        var params = 'q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=5&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,variants.sku,tag' +
          '&section_id=predictive-search';
        var section = fetch(url + '?' + params, controller ? { signal: controller.signal } : undefined)
          .then(function (r) { return r.ok ? r.text() : ''; });
        var ranked = indexUrl ? loadIndex(indexUrl).then(function (index) { return rank(index, q); }) : Promise.resolve([]);
        Promise.all([section, ranked])
          .then(function (out) {
            var html = out[0], hits = out[1];
            if (q !== lastQuery) return;
            var tmp = document.createElement('div');
            tmp.innerHTML = html || '';
            var panel = tmp.querySelector('.predictive__panel');
            if (!panel) {
              if (!hits.length) { close(); return; }
              panel = el('div', 'predictive__panel');
              panel.setAttribute('role', 'listbox');
            }
            mergeProducts(panel, hits, productsLabel);
            results.innerHTML = '';
            results.appendChild(panel);
            results.classList.toggle('predictive--wide', panel.classList.contains('predictive__panel--split'));
            results.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function () { /* aborted or offline: keep whatever is showing */ });
      }

      input.setAttribute('autocomplete', 'off');
      input.setAttribute('aria-expanded', 'false');
      input.addEventListener('focus', function () {
        if (indexUrl) loadIndex(indexUrl);   // warm the index while the visitor starts typing
        if (input.value.trim().length >= MIN_CHARS && results.children.length) results.hidden = false;
      });
      input.addEventListener('input', function () {
        var q = input.value.trim();
        lastQuery = q;
        clearTimeout(timer);
        if (q.length < MIN_CHARS) { close(); return; }
        timer = setTimeout(function () { fetchResults(q); }, DEBOUNCE_MS);
      });
      input.addEventListener('keydown', function (e) {
        var opts = results.querySelectorAll('[role="option"]');
        if (e.key === 'Escape') { close(); return; }
        if (!opts.length || results.hidden) return;
        var i = Array.prototype.indexOf.call(opts, document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
      });
      results.addEventListener('keydown', function (e) {
        var opts = results.querySelectorAll('[role="option"]');
        var i = Array.prototype.indexOf.call(opts, document.activeElement);
        if (e.key === 'Escape') { close(); input.focus(); }
        if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || input).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || input).focus(); }
      });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    });
  }

  window.theme = window.theme || {};
  window.theme.predictiveSearch = { words: words, rank: rank };
  if (window.theme.register) window.theme.register(init);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
})();
